module.exports = __webpack_public_path__ + "img/support.10309d18.png";